export const envNames = {
  DEV: 'DEV',
  PROD: 'PROD',
  SANDBOX: 'DEV',
  STAGE: 'STAGE'
};

export const MUTUAL_FUND = 10;
export const BROKERAGE = 20;
export const MARYLAND_529 = 40;
export const TRAC_PLAN = 50;
export const OMNI_PLAN = 60;
export const ALASKA_529 = 70;
export const NATIONAL_529 = 80;
export const ACTIVE_PLUS = 110;
export const ACTIVE_ADVISORY = 120;

export const accountTypesLabelMapping = {
  [ACTIVE_ADVISORY]: 'Retirement Advisory Services',
  [ACTIVE_PLUS]: 'ActivePlus Portfolios',
  [ALASKA_529]: 'Alaska 529',
  [BROKERAGE]: 'Brokerage',
  [MARYLAND_529]: 'Maryland College Investment Plan',
  [MUTUAL_FUND]: 'Mutual Fund',
  [NATIONAL_529]: 'T. Rowe Price College Savings Plan'
};

export const rmdDashboardLink = {
  [envNames.DEV]: 'https://wwwdev.troweprice.com/usis/rmd-tool',
  [envNames.STAGE]: 'https://wwwstage.troweprice.com/usis/rmd-tool',
  [envNames.PROD]: 'https://www.troweprice.com/usis/rmd-tool',
  [envNames.SANDBOX]: 'https://wwwdev.troweprice.com/usis/rmd-tool'
};

export const CUSTOMER_TYPE_CORE = 7;
export const CUSTOMER_TYPE_PFD = 8;
export const CUSTOMER_TYPE_HNW = 9;
export const CUSTOMER_TYPE_MIL = 10;

export const isCore = customerType => customerType === CUSTOMER_TYPE_CORE;
export const isPreferred = customerType => customerType === CUSTOMER_TYPE_PFD;
export const isHighNetWorth = customerType =>
  customerType === CUSTOMER_TYPE_HNW;
export const isMillionPlus = customerType => customerType === CUSTOMER_TYPE_MIL;

const COLLEGE_SAVINGS = [MARYLAND_529, NATIONAL_529, ALASKA_529];

export const isCollegeSavings = (accountType) => {return COLLEGE_SAVINGS.includes(parseInt(accountType))};

export const collegeSavingsOptions = [
  {
    subject: 'Transactions'
  },
  {
    subject: 'Update Account Information'
  },
  {
    subject: 'Forms'
  },
  {
    subject: 'Tax Information and Forms'
  },
  {
    subject: 'Other'
  }
];

export const messageSubjectOptions = [
  {
    subject: 'Transactions'
  },
  {
    subject: 'Update Account Information'
  },
  {
    subject: 'Forms'
  },
  {
    subject: 'Individual Retirement Account (IRA)'
  },
  {
    subject: 'Tax Information and Forms'
  },
  {
    subject: 'Required Minimum Distribution (RMD)'
  },
  {
    subject: 'Life Events'
  },
  {
    subject: 'Dividend Distributions'
  },
  {
    subject: 'Cost Basis'
  },
  {
    subject: 'Fees'
  },
  {
    subject: 'Other'
  }
];
